/**
 * Configuración global de mutations
 */
export const ON_ROUTE = "ON_ROUTE";
export const ON_IS_LOADING = "ON_IS_LOADING";
export const ON_LANDING = "ON_LANDING";
export const ON_PASO_1 = "ON_PASO_1";
export const ON_GRACIAS = "ON_GRACIAS";
export const ON_ADOBE_APPSTARTED = "ON_ADOBE_APPSTARTED";
